import { IApplicationState } from '../../types/redux';

export function selectRooms(state: IApplicationState) {
  return state.fieldsState.rooms;
}
